




























import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapGetters } from 'vuex'
import { find, filter, orderBy } from 'lodash'

import DepressionMixin from '../DepressionMixin'
import ProgressCircle from '@/components/ProgressCircle.vue'
import { ProcessLog, RunningProcess } from '@/store/workflow/types'

export default mixins(DepressionMixin).extend({
  components: {
    ProgressCircle,
  },
  computed: {
    ...mapGetters('workflow', ['isComplete', 'isDone', 'isDue', 'isActive', 'findLatestProcessBy']),
    latestTreatment(): ProcessLog | undefined {
      return this.$store.getters['workflow/findLatestProcessBy']({
        business_key: 'treatment',
      })
    },
    currentProcess(): ProcessLog | undefined {
      if (this.latestTreatment) {
        const processes: ProcessLog[] = this.$store.getters['workflow/activeProcesses']
        return find(processes, e => {
          return (
            e.root_instance_id === this.latestTreatment!.id &&
            /patient-writes-p\d+/.test(e.business_key || '')
          )
        })
      }
    },
    currentLetter(): number | undefined {
      if (this.currentProcess && this.currentProcess.business_key) {
        const match = this.currentProcess.business_key.match(/patient-writes-p(\d+)/)
        if (match && match[1]) {
          return parseInt(match[1])
        }
      }
    },
    completedProcesses(): ProcessLog[] {
      const out: any[] = []
      if (this.latestTreatment) {
        const processes: ProcessLog[] = this.$store.getters['workflow/completedProcesses']
        return orderBy(
          filter(processes, e => {
            return (
              e.root_instance_id === this.latestTreatment!.id &&
              /patient-writes-p\d+/.test(e.business_key || '')
            )
          }),
          'start_time',
          'desc'
        )
      } else {
        return []
      }
    },
    completedLetters(): number[] {
      return this.completedProcesses.map(p => {
        const match = p!.business_key!.match(/patient-writes-p(\d+)/)
        if (match && match[1]) {
          return parseInt(match[1])
        } else {
          return -1
        }
      })
    },
  },
})
